import React, { useMemo, useCallback } from 'react';
import { CForm, CFormLabel, CFormInput, CRow, CCol, CButton, CFormTextarea } from '@coreui/react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import PermissionsNoPage, { Permissions } from 'src/components/Permissions';

const urlApi = '/log_history_requests';

export async function LoaderLogHistoryRequestsView({ params }) {
  if (!params?.pid) {
    return false;
  }

  const res = await AxiosInstance.get(`${urlApi}/${params.pid}`).then((response) => response);
  return res;
}

const LogHistoryRequestsView = ({ user_data }) => {
  // if (!Permissions(user_data, 'AppRequests', 'VIEW_APPREQUESTS')) {
  //   return <PermissionsNoPage />;
  // }
  const { data } = useLoaderData();
  const navigate = useNavigate();

  const formatValue = useCallback((value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'boolean') return value ? 'Так' : 'Ні';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    return String(value);
  }, []);

  const fields = useMemo(() => {
    if (!data) return [];

    return [
      { key: 'id', label: 'ID', value: formatValue(data.id) },
      { key: 'method', label: 'Метод', value: formatValue(data.method) },
      { key: 'status', label: 'Статус', value: formatValue(data.status) },
      {
        key: 'request',
        label: 'Запит (request)',
        value: formatValue(data.request),
        multiline: true,
      },
    ];
  }, [data, formatValue]);

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  if (!data) {
    return (
      <CForm className="mb-3">
        <p className="text-medium-emphasis mb-3">Дані запиту відсутні.</p>
        <CButton color="secondary" variant="outline" onClick={handleBack}>
          Повернутись
        </CButton>
      </CForm>
    );
  }

  return (
    <CForm className="mb-3">
      <CRow className="g-3">
        {fields.map(({ key, label, value, multiline }) => (
          <CCol md={multiline ? 12 : 6} key={key}>
            <CFormLabel>{label}</CFormLabel>
            {multiline ? (
              <CFormTextarea value={value} disabled readOnly rows={8} />
            ) : (
              <CFormInput type="text" value={value} disabled readOnly autoComplete="off" />
            )}
          </CCol>
        ))}
      </CRow>
      <div className="d-flex justify-content-start mt-4">
        <CButton color="secondary" variant="outline" onClick={handleBack}>
          Повернутись
        </CButton>
      </div>
    </CForm>
  );
};

export default LogHistoryRequestsView;


